import * as React from 'react';
import cx from 'classnames';

import { Search } from '../Search';
import { Flex } from '../Flex';

import './Header.styles.scss';

export class Header extends React.Component {
    render() {
        const { moduleName, className, children, withLiveSearch, liveSearchDelay, searchKeyword, onSearch } = this.props;

        return (
            <div className={cx('Header', className)}>
                <h6 className="Header__module-name">{moduleName}</h6>

                <Flex width="100%" justify="space-between">
                    {onSearch && (
                        <Search 
                            value={searchKeyword}
                            withLiveSearch={withLiveSearch}
                            liveSearchDelay={liveSearchDelay}
                            onSearch={onSearch}
                        />
                    )}
                    {children}
                </Flex>
            </div>
        );
    }
}